import _ from 'lodash'
import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query'
import { Box, Portal, Stack } from '@mui/material'

import { useGetExpertiseMeetingQuery } from '@/core/services/expertise-meeting'
import { useDiagnosticLayout } from '@/layouts/diagnostic/DiagnosticLayout'
import Sidebar from '@/layouts/diagnostic/Sidebar'

import { AskForJoin } from './AskForJoin'
import { QuitMeetingButton } from './QuitMeetingButton'
import { MeetingToolbarContent } from './MeetingToolbarContent'
import { SidebarMenuItemId, useSidebarMenuItems } from '../model/useSidebarMenuItems'
import { MainContent } from './MainContent'

export function ExpertiseMeetingPage() {
  const { topbarContentContainer } = useDiagnosticLayout()
  const { expertiseMeetingId } = useParams<{ expertiseMeetingId: string }>()
  const { data: expertiseMeeting, error } = useGetExpertiseMeetingQuery(expertiseMeetingId ?? skipToken)

  const { sidebarMenuItems, selectedSidebarMenuItem, setSelectedSidebarMenuItem } = useSidebarMenuItems()

  if (_.get(error, 'status') === 403) {
    return (
      <>
        <Portal container={topbarContentContainer}>
          <Stack direction="row" justifyContent="flex-end" width="100%">
            <QuitMeetingButton />
          </Stack>
        </Portal>
        <AskForJoin expertiseMeetingId={expertiseMeetingId} />
      </>
    )
  }

  if (!expertiseMeeting) return null

  return (
    <>
      <Portal container={topbarContentContainer}>
        <MeetingToolbarContent expertiseMeeting={expertiseMeeting} />
      </Portal>
      <Stack direction="row" flex={1}>
        <Sidebar
          menuItems={sidebarMenuItems}
          onSelect={(menuItemId) => setSelectedSidebarMenuItem(menuItemId as SidebarMenuItemId)}
          selectedMenuItem={selectedSidebarMenuItem}
        />
        <MainContent expertiseMeeting={expertiseMeeting} selectedSidebarMenuItem={selectedSidebarMenuItem} />
      </Stack>
    </>
  )
}
